<app-wizard-bar-nav [stepIsDirty]="this.isQuoteRequestInvalidated()"></app-wizard-bar-nav>
<div class="step-container">
  <h2 *ngIf="originalQuoteRequestId">Renewing Quote {{ originalQuoteRequestId }}</h2>
  <h2 *ngIf="originalQuoteRequestDueDate">Your new contract start date must be later than {{ originalQuoteRequestDueDate | date }}</h2>
  <h3>Utility Accounts | <em heading-info [quoteInfo]="quoteRequestState"></em></h3>

  <app-utility-accounts-grid
    *ngIf="!(isSupplierManagerManualEntry() | async)"
    [quoteRequestId]="quoteRequestId"
    (init)="gridInit($event)"
    [quoteRequestState]="quoteRequestState"
    [userIdentity]="userIdentity"
    [showRateCode]="false"
    [nextButtonClicked]="nextButtonClicked.asObservable()"
  ></app-utility-accounts-grid>

  <app-utility-accounts-grid
    *ngIf="isSupplierManagerManualEntry() | async"
    [quoteRequestId]="quoteRequestId"
    (init)="gridInit($event)"
    [quoteRequestState]="quoteRequestState"
    [userIdentity]="userIdentity"
    [showRateCode]="true"
    [nextButtonClicked]="nextButtonClicked.asObservable()"
  ></app-utility-accounts-grid>
</div>

<app-wizard-step-nav-buttons (backClicked)="back()" (nextClicked)="next()"></app-wizard-step-nav-buttons>
